import { jsx as _jsx } from "react/jsx-runtime";
import { useTabHandler } from '../../../../hooks/useTabHandler';
import { DownlinkQueueView } from './DownLinkQueueView';
import { DownlinkHistory } from './DownLinksHistory';
const debug = process.env.REACT_APP_DEBUG && false;
export const DownlinksView = () => {
    const tabsToDisplay = {
        Queue: () => _jsx(DownlinkQueueView, {}),
        History: () => _jsx(DownlinkHistory, {}),
    };
    const { tabs } = useTabHandler(tabsToDisplay, true, 1);
    return tabs;
};
